import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle, IconInfoCircle, IconX } from '@tabler/icons-react';

const defaultId = 'default-alert';

const toastConfig = {
	position: 'top-center',
	withCloseButton: true,
	autoClose: 5000,
	title: 'Success',
	message: '',
	color: 'green',
	icon: <IconX />,
	loading: false,
};

export const alertService = {
    alert,
    clear,
    error,
    info,
    success,
    warn
};

export const alertType = {
    error: 'error',
    info: 'info',
    success: 'success',
    warning: 'warning'
}

function success(message) {
  clear();
  notifications.show({
		...toastConfig,
		message: message,
		icon: <IconCheck />,
  });
  // alert({ ...options, message, type: alertType.success });
}

function error(message) {
  clear();
  notifications.show({
		...toastConfig,
		message: message,
		title: 'Error',
		icon: <IconX />,
		color: 'red',
  });
  // alert({ ...options, message, type: alertType.error });
}

function info(message) {
  clear();
  notifications.show({
		...toastConfig,
		message: message,
		title: 'Info',
		icon: <IconInfoCircle />,
		color: 'blue',
  });
  // alert({ ...options, message, type: alertType.info });
}

function warn(message) {
  clear();
  notifications.show({
		...toastConfig,
		message: message,
		title: 'Warning',
		icon: <IconExclamationCircle />,
		color: 'yellow',
  });
  // alert({ ...options, message, type: alertType.warning });
}

function clear(id = defaultId) {
  notifications.clean();
}
